/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	UserProfileClientForConfluenceQuery$data as UserProfileClientForConfluenceQuery,
	UserProfileClientForConfluenceQuery$variables as UserProfileClientForConfluenceQueryVariables,
} from '../__generated__/UserProfileClientForConfluenceQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { UserProfileClientForConfluenceQuery$data } from '../__generated__/UserProfileClientForConfluenceQuery.graphql.ts';
export type UserProfileClientForConfluenceQuery_user_AtlassianUser_confluence_ConfluenceUser = NonNullable<NonNullable<UserProfileClientForConfluenceQuery$data['user']>['confluence']>;
export type UserProfileClientForConfluenceQuery_user_AtlassianUser = NonNullable<UserProfileClientForConfluenceQuery$data['user']>;
export type UserProfileClientForConfluenceQuery_entitlements_Entitlements_externalCollaborator_ExternalCollaboratorFeature = NonNullable<UserProfileClientForConfluenceQuery$data['entitlements']>['externalCollaborator'];
export type UserProfileClientForConfluenceQuery_entitlements_Entitlements = NonNullable<UserProfileClientForConfluenceQuery$data['entitlements']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

